module.exports = __webpack_public_path__ + "static/media/diestrammena_asynamora.3e3964eb.jpg";